import CaptainAssistantAPI from 'dashboard/api/captain/assistant';
import { createStore } from './storeFactory';

export default createStore({
  name: 'CaptainAssistant',
  API: CaptainAssistantAPI,
  actions: mutationTypes => ({
    async updateCustomTools({ commit, state }, { assistantId, customToolIds }) {
      commit(mutationTypes.SET_UI_FLAG, { updatingItem: true });
      try {
        const response = await CaptainAssistantAPI.updateCustomTools(
          assistantId,
          customToolIds
        );

        const assistant = state.records.find(r => r.id === assistantId);
        if (assistant) {
          const updatedToolIds = response.data.map(tool => tool.id);
          commit(mutationTypes.UPSERT, {
            ...assistant,
            custom_tool_ids: updatedToolIds,
          });
        }
      } finally {
        commit(mutationTypes.SET_UI_FLAG, { updatingItem: false });
      }
    },
  }),
});
